/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".meses[_ngcontent-%COMP%]{display:-webkit-box;display:flex;flex-wrap:wrap;-webkit-column-gap:50px;-moz-column-gap:50px;column-gap:50px;row-gap:30px;padding-left:30px;padding-right:15px;-webkit-box-pack:center;justify-content:center}saiba-mais[_ngcontent-%COMP%]{float:right}"];
export { styles as styles };
